export const ActionsTypes = {
  authAdmin: "authAdmin",
}
